import React from 'react'
import "./refundpolicy.css"; 
export const Refundpolicy = () => {
  return (
<div className="policy-wrapper py-5">
  <div className="policy-header">
    <h1>Refund Policy</h1>
    
    <p>
      Welcome to https://topfaculty.co.in/  This Refund Policy
      explains the terms under which refunds may be granted for services
      purchased through our platform.
    </p>
  </div>
  <div className="policy-list">
    <div className="policy-item">
      <div className="circle">1</div>
      <h2>Nature of Services</h2>
      <p>
        TopFaculty provides academic support services including coaching
        guidance information, faculty assistance coordination, course-related
        counselling support, infrastructure facility information, and student
        enquiry facilitation services.
      </p>
      <p>
        Since many of our services involve consultation time, counselling
        effort, administrative coordination, and academic facilitation, refund
        eligibility is limited to the situations listed below.
      </p>
    </div>
    <div className="policy-item">
      <div className="circle">2</div>
      <h2>Eligibility for Refund</h2>
      <ul>
        <li>Duplicate payment made by mistake</li>
        <li>Payment deducted but service not initiated from our side</li>
        <li>
          Transaction failure where amount is debited but confirmation not
          received
        </li>
      </ul>
      <span className="highlight">Request within 7 Days</span>
    </div>
    <div className="policy-item">
      <div className="circle">3</div>
      <h2>Non-Refundable Cases</h2>
      <ul>
        <li>Admission or registration completed successfully</li>
        <li>Demo class attended</li>
        <li>Counselling or consultation already provided</li>
        <li>Study material issued or shared</li>
        <li>Seat reserved in any batch</li>
        <li>Student voluntarily withdraws after enrolment</li>
        <li>Incorrect information submitted by the student</li>
      </ul>
    </div>
    <div className="policy-item">
      <div className="circle">4</div>
      <h2>Refund Processing Timeline</h2>
      <p>
        Approved refunds will be processed within 7–10 working days to the
        original payment method.
      </p>
      <p>Actual credit timing depends on the bank or payment gateway.</p>
    </div>
    <div className="policy-item">
      <div className="circle">5</div>
      <h2>Refund Request Procedure</h2>
      <p>
        Email us at <strong>support@topfaculty.co.in</strong>
      </p>
      <ul>
        <li>Student Name</li>
        <li>Registered Mobile Number</li>
        <li>Transaction ID</li>
        <li>Course Name</li>
        <li>Reason for refund request</li>
      </ul>
    </div>
    <div className="policy-item">
      <div className="circle">6</div>
      <h2>Cancellation by TopFaculty</h2>
      <ul>
        <li>Incomplete documentation</li>
        <li>Batch availability issues</li>
        <li>Eligibility mismatch</li>
        <li>Suspicious or fraudulent activity</li>
      </ul>
      <p>
        In such cases, a partial or full refund may be issued at the discretion
        of TopFaculty.
      </p>
    </div>
    <div className="policy-item">
      <div className="circle">7</div>
      <h2>Policy Updates</h2>
      <p>
        TopFaculty reserves the right to update this Refund Policy at any time
        without prior notice. Updated versions will be published on this page.
      </p>
    </div>
  </div>
 </div>



  )
}
